(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/pages/page-widget.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/pages/page-widget.js');
"use strict";


const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const {
  PageHeader
} = svs.bingo_react.components.page_header;
const WidgetPage = _ref => {
  let {
    widgetAreaIndex,
    headerConfig
  } = _ref;
  if (widgetAreaIndex === 'bingoWidgetArea_0') {
    return null;
  }
  return React.createElement("div", {
    className: "bingo-main-content-container-full-width"
  }, React.createElement(PageHeader, {
    headerConfig: headerConfig
  }), React.createElement(WidgetArea, {
    widgetArea: widgetAreaIndex
  }));
};
setGlobal('svs.bingo_react.pages.WidgetPage', WidgetPage);

 })(window);